import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

/**
 * Core positioning block — respectful "we honour Dubai, we go further for you" framing.
 * Used on Home and Why-MAVULA pages.
 */
export default function PositioningHero() {
  return (
    <section className="py-16 md:py-24 border-y mv-hairline" data-testid="positioning-hero"
             style={{ background: "linear-gradient(180deg, rgba(212,175,55,0.06), rgba(10,59,40,0.04))" }}>
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Core Positioning</span></div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-6xl mv-green-text mt-3 leading-[1.0]">
          Dubai turned a desert into a global destination.{" "}
          <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>
            We turn your birthright into your forever home.
          </span>
        </h2>

        <div className="mt-8 mv-card p-6 md:p-8" style={{ background: "#fff" }}>
          <div className="flex items-start gap-3">
            <Sparkles size={22} className="mv-green-text shrink-0" style={{ color: "var(--mv-gold)" }}/>
            <div className="text-[15px] md:text-[16.5px] leading-relaxed" style={{ color: "var(--mv-text)" }}>
              <p>
                Dubai showed the world what vision can build — but it was designed for
                <b className="mv-green-text"> global visitors and wealthy investors</b>.
              </p>
              <p className="mt-4">
                MAVULA is designed for <b className="mv-green-text">you</b>. For Southern African
                citizens — at home or across the world — who want <b className="mv-green-text">true
                ownership, dignity, and a future rooted in your own land</b>.
              </p>
              <p className="mt-4 font-accent italic text-[16px] md:text-[18px]" style={{ color: "var(--mv-gold)" }}>
                "We don't ask about your visas or your bank balance.
                We ask only — is this your home?"
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/why-mavula" className="btn-gold" data-testid="positioning-hero-cta">
            Read: Why MAVULA <ArrowRight size={16}/>
          </Link>
          <Link to="/register-interest" className="btn-ghost" data-testid="positioning-hero-register">
            Open an account
          </Link>
        </div>
      </div>
    </section>
  );
}
